import React from 'react'

const SuperwomenBuddhi = () => {
  return (
    <div>SuperwomenBuddhi</div>
  )
}

export default SuperwomenBuddhi